<template>
  <div class="ege-strategy-modal">
    <div
      v-if="!successSend"
      class="ege-strategy-modal__inner"
    >
      <img
        src="/v2/ege/modal/close-ege.svg"
        alt="close"
        class="ege-strategy-modal__close"
        @click="$emit('closeModal')"
      >

      <h6 class="ege-strategy-modal__title">
        Оставь заявку и получи стратегию подготовки к ЕГЭ
      </h6>

      <p class="ege-strategy-modal__description">
        Заполни и скачай .pdf с разбором стратегии и чек-лист шпаргалку
      </p>

      <div class="ege-strategy-modal__fields">
        <form-name-field
          ref="nameField"
          v-model="nameInput"
          :class="['form__input', { 'ege': page === 'ege' }]"
          placeholder="Имя"
        />

        <form-phone-field
          ref="phoneField"
          v-model="phoneInput"
          :class="['form__input', 'form__input_phone', { 'ege': page === 'ege' }]"
          :errors-list="submitError"
          :error="validForm === false"
        />

        <form-email-field
          ref="emailField"
          v-model="emailInput"
          :class="['form__input', 'form__input_email', { 'ege': page === 'ege' }]"
          :submit-error="submitError"
          placeholder="Почта"
          @clearSubmitError="clearSubmitError"
        />
      </div>

      <button
        class="ege-strategy-modal__btn"
        @click="submit"
      >
        Скачать файлы
      </button>

      <p class="ege-strategy-modal__law">
        Нажимая на кнопку, вы соглашаетесь
        <br>
        <nuxt-link
          to="/privacy"
          target="_blank"
        >
          c условиями обработки данных
        </nuxt-link>
      </p>

      <div class="ege-strategy-modal__social">
        <p>
          Или напишите нам в чат:
        </p>

        <div class="ege-strategy-modal__social-items">
          <a
            href="https://wa.me/79686286327"
            target="_blank"
            rel="nofollow"
            class="whatsapp"
          >
            <img
              src="/v2/ege/modal/whatsapp.svg"
              alt="whatsapp"
            >
          </a>
          <a
            :href="$telegramBotLink($route)"
            target="_blank"
            rel="nofollow"
            class="telegram"
          >
            <img
              src="/v2/ege/modal/telegram.svg"
              alt="telegram"
            >
          </a>
          <a
            href="mailto:online.school@synergy.ru"
            target="_blank"
            rel="nofollow"
            class="email"
          >
            <img
              src="/v2/ege/modal/email.svg"
              alt="email"
            >
          </a>
        </div>
      </div>
    </div>

    <div
      v-else
      class="ege-strategy-modal__inner"
    >
      <img
        src="/v2/ege/modal/close.svg"
        alt="close"
        class="ege-strategy-modal__close"
        @click="$emit('closeModal')"
      >

      <p class="ege-strategy-modal__ready">
        Готово!
      </p>

      <h6 class="ege-strategy-modal__title">
        Спасибо, что заполнили форму, скачивание скоро начнется
      </h6>

      <img
        src="/v2/ege/modal/success-image.png"
        alt="success"
        class="ege-strategy-modal__icon"
      >

      <p class="ege-strategy-modal__files">
        Если скачивание не началось, то можете скачать .pdf файл
        <a
          :href="files[0].path"
          download
          target="_blank"
        >
          по этой ссылке
        </a>
        и
        <a
          :href="files[1].path"
          download
          target="_blank"
        >
          этой ссылке
        </a>
      </p>
    </div>

    <div
      class="ege-strategy-modal__overlay"
      @click="$emit('closeModal')"
    />
  </div>
</template>

<script>
import FormNameField from '@/components/v2/common/fileds/FormNameField.vue';
import FormEmailField from '@/components/v2/common/fileds/FormEmailField.vue';
import FormPhoneField from '@/components/v2/common/fileds/FormPhoneField.vue';
import sendLeadMixinConstructor from '@/mixins/sendLeadMixinConstructor';

const sendLeadMixin = sendLeadMixinConstructor({
  needPhone: true,
  needEmail: true,
  needToSendTitle: true,
});

export default {
  name: 'ExamStrategyModal',
  components: {
    FormPhoneField,
    FormEmailField,
    FormNameField,
  },
  mixins: [sendLeadMixin],

  props: {
    modalType: {
      type: String,
      default: '',
    },
    page: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    successSend: false,
  }),
  computed: {
    getModalTitle() {
      const titles = {
        marathon: 'Пройди регистрацию и получи доступ к марафону прямо сейчас',
        course: 'Пройди регистрацию и получи доступ к урокам прямо сейчас',
      };

      return titles[this.modalType] || '';
    },
    titleToSend() {
      return this.getModalTitle.replace(/<\/?[^>]+(>|$)/g, '');
    },
    russianFiles() {
      return [
        {
          name: 'Методичка по русскому.pdf',
          path: '/v2/ege/modal/Методичка по русскому.pdf',
        },
        {
          name: 'Шпаргалка по русскому.pdf',
          path: '/v2/ege/modal/Шпаргалка по русскому.pdf',
        },
      ];
    },
    mathFiles() {
      return [
        {
          name: 'Методичка_по_профильной_математике.pdf',
          path: '/v2/ege/modal/Методичка_по_профильной_математике.pdf',
        },
        {
          name: 'шпаргалка_по_профильной_математике.pdf',
          path: '/v2/ege/modal/шпаргалка_по_профильной_математике.pdf',
        },
      ];
    },
    files() {
      if (this.modalType === 'russian') {
        return this.russianFiles;
      }
      if (this.modalType === 'math') {
        return this.mathFiles;
      }
      return [];
    },
  },

  methods: {
    onSubmit() {
      this.successSend = true;

      this.files.forEach((file) => {
        const clickEvent = new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: false,
        });

        const url = file.path;
        const link = document.createElement('a');
        link.href = url;
        link.download = file.name;
        link.dispatchEvent(clickEvent);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ege-strategy-modal {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  &__inner {
    width: 610px;
    max-height: 98vh;
    overflow: auto;
    box-sizing: border-box;
    padding: 40px;
    position: relative;
    z-index: 1;

    border-radius: 20px;
    border: 2px solid $black-color;
    background: $white-color;
    box-shadow: 4px 4px 0 0 #000;

    @include media-down(tablet) {
      width: 100%;
      max-width: 344px;
      padding: 40px 8px;
    }
  }
  &__inner {
    border: none;
    box-shadow: 4px 4px 20px 0 rgba($ege-blue-darkest, .05), 10px 10px 50px 0 rgba($ege-blue-darkest, .1);
  }

  &__close {
    position: absolute;
    right: 0;
    top: 0;

    cursor: pointer;
  }

  &__close {
    position: absolute;
    right: 0;
    top: 0;

    cursor: pointer;
  }

  &__ready {
    margin-bottom: 12px;

    font-size: 24px;
    font-weight: 500;
    line-height: 31px;
    text-align: center;
    color: #89C053;

    @include media-down(tablet) {
      margin-bottom: 8px;

      font-size: 18px;
      line-height: 22px;
    }
  }

  &__icon {
    display: block;
    margin: 32px auto 0;
    width: 202px;

    @include media-down(tablet) {
      margin-top: 24px;
      width: 170px;
    }
  }

  &__files {
    max-width: 384px;
    margin: 32px auto 0;

    font-size: 20px;
    font-weight: 500;
    line-height: 26px;
    text-align: center;
    color: $black-color;

    a {
      color: $header-dark-orange;

      @include media-down(tablet) {
        font-weight: 600;
      }
    }

    @include media-down(tablet) {
      margin-top: 24px;

      font-size: 16px;
      line-height: 19px;
    }
  }

  &__title {
    text-align: center;
    font-size: 34px;
    font-weight: 700;
    line-height: 100%;
    letter-spacing: -1.2px;
    color: $black-color;

    @include media-down(tablet) {
      font-size: 24px;
      letter-spacing: -0.48px;
    }

    ::v-deep & > span {
      display: inline-block;
      position: relative;

      span {
        position: relative;
        z-index: 2;
        color: $ege-orange;
      }
    }
  }

  &__description {
    max-width: 414px;
    margin: 10px auto 0;

    text-align: center;
    font-variant-numeric: lining-nums proportional-nums;
    font-size: 24px;
    font-weight: 500;
    line-height: 130%;
    color: $grey2;

    @include media-down(tablet) {
      margin: 8px auto 0;

      font-size: 18px;
      font-weight: 600;
      line-height: 100%;
    }
  }

  &__fields {
    margin-top: 40px;

    @include media-down(tablet) {
      margin-top: 16px;
    }

    .form__input {
      margin: 0 auto 10px;

      @include media-down(tablet) {
        margin-bottom: 8px;
      }

      ::v-deep input:not(.phone-field__input) {
        width: 100%;
        height: auto;
        padding: 21px 18px;

        border-radius: 100px;
        border: 1px solid rgba($black-color, .2);

        font-size: 20px;
        font-weight: 400;
        letter-spacing: 0.4px;
        line-height: 1;
        color: $black-color;

        &::placeholder {
          color: $grey2;
        }

        @include media-down(tablet) {
          padding: 16px 14px 16.5px;

          font-size: 18px;
        }
      }

      ::v-deep .phone-field__input {
        padding-top: 20px;
        padding-bottom: 22px;

        font-size: 20px;
        font-weight: 400;
        letter-spacing: 0.4px;

        @include media-down(tablet) {
          font-size: 18px;
        }
      }
    }
  }

  &__btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 70px;
    margin-top: 20px;

    border-radius: 100px;
    background-color: $ege-orange;
    border: 2px solid $brown-dark;
    box-shadow: 0 4px 0 0 $brown-dark;

    text-align: center;
    font-variant-numeric: lining-nums proportional-nums;
    font-size: 30px;
    color: $white-color;
    font-weight: 700;
    line-height: normal;

    cursor: pointer;
    transition: transform .2s ease-out, box-shadow .2s ease-out;

    @include media-down(tablet) {
      margin-top: 8px;
      height: 60px;

      transform: translate(-4px, -4px);
      box-shadow: 4px 4px 0 0 $black-color;

      font-size: 24px;
    }

    &:hover {
      box-shadow: 0 0 0 0 $brown-dark;
      transform: translate(0, 4px);
    }
  }

  &__law {
    max-width: 384px;
    margin: 10px auto 0;

    text-align: center;
    font-variant-numeric: lining-nums proportional-nums;
    font-size: 18px;
    font-weight: 600;
    line-height: 100%;
    color: #919191;

    @include media-down(tablet) {
      margin-top: 8px;

      font-size: 16px;
      line-height: 120%;
    }

    a {
      color: $ege-orange;
    }
  }

  &__social {
    margin-top: 32px;

    @include media-down(tablet) {
      margin-top: 24px;
    }

    p {
      font-variant-numeric: lining-nums proportional-nums;
      font-size: 20px;
      font-weight: 500;
      line-height: 26px;
      text-align: center;
      color: $black-color;

      @include media-down(tablet) {
        font-size: 16px;
        font-weight: 600;
        line-height: 19px;
      }
    }

    &-items {
      display: flex;
      justify-content: center;
      gap: 10px;
      margin-top: 16px;

      @include media-down(tablet) {
        margin-top: 12px;
      }

      a {
        display: inline-block;
        width: 50px;
        height: 50px;
        overflow: hidden;

        border-radius: 10px;
        transform: translate(-2px, -2px);

        transition: transform .2s ease-out, box-shadow .2s ease-out;

        img {
          width: 100%;
        }
      }
      a.whatsapp {
        border: 2px solid #168B25;
        box-shadow: 2px 2px 0 0 #168B25;

        &:hover {
          transform: translate(0, 0);
          box-shadow: 0 0 0 0 #168B25;
        }
      }
      a.telegram {
        border: 2px solid #016EA3;
        box-shadow: 2px 2px 0 0 #016EA3;

        &:hover {
          transform: translate(0, 0);
          box-shadow: 0 0 0 0 #016EA3;
        }
      }
      a.email {
        border: 2px solid #044396;
        box-shadow: 2px 2px 0 0 #044396;

        &:hover {
          transform: translate(0, 0);
          box-shadow: 0 0 0 0 #044396;
        }
      }
    }
  }

  &__overlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;

    background-color: rgba($black-color, 0.3);
    -webkit-backdrop-filter: blur(2.5px);
    backdrop-filter: blur(2.5px);

    cursor: pointer;
  }
}
</style>
